import { Tabs } from 'antd'
import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  background-color: white;
  border-radius: 4px;
  justify-content: center;
  margin: 13px;
  /* padding: 60px; */
  width: 100%;
  height: 100%;
`

export const TabPane = styled(Tabs.TabPane)`
  padding: 1rem;
`
